module.exports = "https://trybtryb-legacy.web.app/img/avatar.7ee49ee4.svg";